/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2017, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(['./SmartsToVizMapping'],function(SmartsToVisMapping){
	'use strict';
	let VisToSmartMapping = {};
	const smartsChartTypes = Object.keys(SmartsToVisMapping);
	smartsChartTypes.forEach(function(chartType){
		let oldMapInfo = SmartsToVisMapping[chartType];
		if( !VisToSmartMapping[oldMapInfo.visId] ){
			VisToSmartMapping[oldMapInfo.visId] = {};
		}
		let newMapInfo = VisToSmartMapping[oldMapInfo.visId];
		let chartProps = Object.keys(SmartsToVisMapping[chartType]);
		chartProps.forEach(function(prop){
			if( prop === 'visId' ){
				if( !newMapInfo.chartType ){
					newMapInfo.chartType = chartType;
				}
			} else {
				if( !newMapInfo[oldMapInfo[prop]] ){
					newMapInfo[oldMapInfo[prop]] = prop;
				}
			}
		});
	});
	return VisToSmartMapping;
});
